module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.woff?f056755c8cd097b5f5ffde3e98387631";